export default __webpack_public_path__ + "static/media/fp.4e096157.png";